import { useQuery } from "@tanstack/react-query";

import { darwinService } from "@/services/darwinService";

const ELITAI_CONNECTION_REFETCH_MS = 30_000;

/** True when elitai-svc has no Darwin route, or the request cannot reach it. */
export function useElitaiConnection(): { isDisconnected: boolean } {
    const connection = useQuery({
        queryKey: ["elitai-svc", "connection"],
        queryFn: () => darwinService.checkConnection(),
        retry: false,
        refetchInterval: ELITAI_CONNECTION_REFETCH_MS,
    });

    return { isDisconnected: connection.isError };
}
